<template>
  <div class="card__certificate-wrapper card card-box w-100">
    <div class="card-body">
      <b-row>
        <b-col cols="12" sm="6" class="d-flex flex-column justify-content-between my-4">
          <div class="w-100 d-flex justify-content-center">
            <badge-image :src="certificateImageLink" large></badge-image>
          </div>
          <div v-if="accredibleLink" class="w-100 d-flex justify-content-center mt-3">
            <a
              id="view-badge-detail"
              :href="accredibleLink"
              target="_blank"
              style="text-decoration: none"
              >View Badge Detail</a
            >
          </div>
        </b-col>
        <b-col cols="12" sm="6" class="d-flex flex-column my-4">
          <BaseUserProfile :user-name="userFullName">
            <template slot="name">
              <div class="ml-2">
                <div ref="user--fullname" class="font-weight-bold">
                  {{ userFullName }}
                </div>
              </div>
            </template>
          </BaseUserProfile>

          <div class="mt-4">
            <div><b>Issued On</b></div>
            <p id="issuer-submit-date" class="mb-0">
              {{ dateString }}
            </p>
          </div>
          <!-- <div class="mt-4">
            <div><b>Get Sharable Link</b></div>
            <div class="d-flex flex-row mt-2">
              <button id="btn-popup-share" class="btn btn-outline-primary mr-3">
                Share
              </button>
            </div>
          </div> -->
        </b-col>
      </b-row>

      <!-- Certificate image -->
      <!-- <div class="d-flex justify-content-center card__certificate mx-2 mt-4">
        <div class="d-flex align-items-center">
          <img :src="certificateImageLink" height="300px" />
        </div>
      </div> -->

      <!-- Accredible button -->
      <!-- <b-button
        variant="primary"
        class="mt-4"
        :href="accredibleLink"
        :disabled="accredibleLink === null ? true : false"
      >
        View on Accredible
      </b-button> -->
    </div>
  </div>
</template>

<script>
import { datetimeMixin } from '@/mixins/datetimeMixin';
import BaseUserProfile from '@/components/base-components/BaseUserProfile';
import BadgeImage from '@/components/Credential/BadgeImage';
import User from '@/models/User';

export default {
  components: {
    BadgeImage,
    BaseUserProfile
  },

  mixins: [datetimeMixin],

  props: {
    certificateImageLink: {
      type: String,
      default: require('@/assets/4life-Cer-Default.jpg')
    },
    accredibleLink: {
      type: String,
      default: null
    },
    date: {
      type: Date,
      default: () => new Date()
    },
    user: {
      type: User,
      default: null
    }
  },

  computed: {
    dateString() {
      return `${this.formatedDatetime(this.date, 'MMM DD, YYYY')}`;
    },

    userFullName() {
      return `${this.user.firstname} ${this.user.lastname}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.card__certificate-wrapper {
  max-width: 910px;
}

.card__certificate {
  height: 300px;
  border-radius: 10.4px;
  background: #eeeff8;
}

.text__publish-time {
  color: rgba(7, 9, 25, 0.5);
}
</style>
